import { render, staticRenderFns } from "./modalEditPointMember.vue?vue&type=template&id=4be6712f"
import script from "./modalEditPointMember.vue?vue&type=script&lang=js"
export * from "./modalEditPointMember.vue?vue&type=script&lang=js"
import style0 from "./modalEditPointMember.vue?vue&type=style&index=0&id=4be6712f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports